import { TypeMovement } from '../../interfaces'
import { TypeMovementAction } from '../actions/typeMovementActions'
import { GET_TYPE_MOVEMENTS_EXITO } from '../types/typeMovementActionTypes'

export interface TypeMovementState {
  typeMovementsState: {
    typeMovements?: TypeMovement[] | undefined
    error?: string | undefined
  }
}

const initialState: TypeMovementState = {
  typeMovementsState: { typeMovements: [], error: '' }
}

export const typeMovementReducer = (
  state: TypeMovementState = initialState,
  action: TypeMovementAction
): TypeMovementState => {
  if (action.type === GET_TYPE_MOVEMENTS_EXITO) {
    return {
      ...state,
      typeMovementsState: {
        typeMovements: action.typeMovements,
        error: action.error
      }
    }
  }
  return state
}
